<template>
    <div>
        <v-toolbar flat color="white">
        <v-spacer></v-spacer> 
        <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
                max-width="50px"
                class="pa-3"
                clearable
              ></v-text-field> 
              <v-btn round color="primary" @click="addItem()">Add Ticket Template</v-btn></v-toolbar>
        <v-data-table 
            :loading="isLoading"
            :search="search"
            :items="ticketTemplates" :headers="headers">
            <template v-slot:items="props">
                <td class="text-xs-center">
                    <v-icon @click="editItem(props.item)">edit</v-icon>
                    <v-icon @click="deleteItem(props.item)">delete</v-icon>
                </td>
                <td class="text-xs-center">
                    {{props.item.name}}
                </td>
                <td class="text-xs-center">
                    {{props.item.description}}
                </td>
                 <td v-if="props.item.ticketCategoryItem!=null" class="text-xs-center">
                    {{props.item.ticketCategoryItem.name}}
                </td>
                 <td v-else class="text-xs-center">
                </td>
                <!-- <td v-if="props.item.contact!=null" class="text-xs-center">
                    {{props.item.contact.name}} {{props.item.contact.surname}}
                </td>
                <td v-else class="text-xs-center">
                </td> -->
               

            </template>
        </v-data-table>
        <v-dialog v-model="addModal" persistent   max-width="750px">
            <v-card>
                <v-toolbar flat color="primary">
                    <h3 class="title white--text">Add Ticket Template</h3>
                     <v-spacer></v-spacer>                    
                        <v-btn flat color="white" class="white--text" @click="createNew()">Save</v-btn>
                       
                        <v-btn flat color="white" class="white--text" @click="addModal=false, ticketItem={}">X</v-btn>
                  </v-toolbar>
                  <v-card-text>
                   <v-layout >
                   <v-flex xs6 mx-3>
                        <v-text-field label="Name" v-model="ticketItem.name"></v-text-field>
                        </v-flex>
                        <v-flex xs6 mx-3>
                         <v-text-field label="Description" v-model="ticketItem.description"></v-text-field>
                          </v-flex>
                       </v-layout>
                    
                    <v-layout>
                        <v-flex xs6 mx-3>
                        <v-autocomplete ref="ticketCategories" v-on:blur="$refs['ticketCategories'].blur()" :items="ticketCategories" label="Select a Ticket Category" item-text="name" item-value="id" v-model="ticketItem.ticketCategoryId"></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 mx-3>
                        <v-autocomplete ref="ticketCategoryId" v-on:blur="$refs['ticketCategoryId'].blur()" v-if="ticketItem.ticketCategoryId" :items="filteredCategoryItems" label="Select a Category Item" item-text="name" item-value="id" v-model="ticketItem.ticketCategoryItemId"></v-autocomplete>
                        <v-autocomplete  v-else disabled :items="ticketCategories" label="Select a Category Item" item-text="name" item-value="id"></v-autocomplete>
                    </v-flex>
                     </v-layout>
                </v-card-text>            
    
            </v-card>
        </v-dialog>
        <v-dialog v-model="editModal" persistent max-width="750px">
            <v-card >
                <v-toolbar flat color="primary">
                    <h3 class="title white--text">Edit Workflow</h3>                
               <v-spacer></v-spacer>                    
                        <v-btn flat color="white" class="white--text" @click="update()">Save</v-btn>                       
                        <v-btn flat color="white" class="white--text" @click="editModal=false">X</v-btn>
                  </v-toolbar>
                  <v-card-text>
                   <v-layout >
                   <v-flex xs6 mx-3>
                        <v-text-field label="Name" v-model="ticketItem.name"></v-text-field>
                        </v-flex>
                        <v-flex xs6 mx-3>
                         <v-text-field label="Description" v-model="ticketItem.description"></v-text-field>
                          </v-flex>
                       </v-layout>                    
                    <v-layout>
                    <v-flex xs6 mx-3>
                        <v-autocomplete ref="ticketCategories" v-on:blur="$refs['ticketCategories'].blur()" xs6 :items="ticketCategories" label="Select a Ticket Category" item-text="name" item-value="id" v-model="ticketItem.ticketCategoryId"></v-autocomplete>
                    </v-flex>
                    <v-flex xs6 mx-3>
                        <v-autocomplete ref="ticketCategoryId" v-on:blur="$refs['ticketCategoryId'].blur()" v-if="ticketItem.ticketCategoryId" xs6 :items="filteredCategoryItems" label="Select a Category Item" item-text="name" item-value="id" v-model="ticketItem.ticketCategoryItemId"></v-autocomplete>
                        <v-autocomplete v-else xs6 disabled :items="ticketCategories" label="Select a Category Item" item-text="name" item-value="id"></v-autocomplete>
                    </v-flex>
                      </v-layout>                    
                   
                </v-card-text>               
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Api from '@/services/Api.js'
import dateformat from "dateformat";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
export default {
    components: {
       VueCtkDateTimePicker: VueCtkDateTimePicker,
    },
    data(){
        return {
            filteredCategoryItems: [],
            ticketCategoryItems:[],
            ticketCategories:[],
            today: this.formatDate(new Date()),
            ticketTemplates:[],
            dateTimeSelect: true,
            ticketItem: {},
            subItem:{},
            key: 0,
            overData: null,
            isLoading: true,
            search: '',
            addModal: false,
            editModal: false,
            item: {
                name: '',
                ticketCategoryItems:{}
                },
            name:'',
            code:'',
            workflows:[],
            ticketCategoryItems:[],
            headers: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Name",
          align: "center",
          value: "name"
      },
       {
          text: "Description",
          align: "center",
          value: "description"
      },
       {
          text: "Ticket Category Item",
          align: "center",
          value: "ticketCategoryItem.name"
      },
      ]
        }
    },
    watch:{
    'ticketItem.ticketCategoryId': {
            immediate: true,
            async handler(value){
                if(value && value!==null){
                    this.filteredCategoryItems= await this.ticketCategoryItems.filter(function(el){
                        return el.ticketCategoryId === value
                    })
                } else {
                    this.filteredCategoryItems= this.ticketCategoryItems
                }
            }
        },
    },
    created(){
        this.fetchTicketTemplates()
        this.fetchOrgContacts()
        this.fetchTicketCategories()
        this.fetchTicketCategoryItems()
    },
    methods: {
        fetchOrgContacts(){
           this.filteredUsers=[]
        Api()
        .get('/organisationContact')
        .then(async response=>{
            this.filteredUsers = response.data.filter(function(el){
                return el.userType !=='endClient'
            })
            let contactArray = await this.filteredUsers.map(x=>x.contact)
            this.filteredUsers = contactArray
        })
    },
         formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
        fetchTicketTemplates(){
                   Api()
                    .get('/ticketTemplate').then(response=>{
                        this.ticketTemplates=response.data
                    }).then(response=>{
                        this.isLoading=false})
        },
        fetchTicketCategoryItems(){
            Api()
            .get('/ticketCategoryItem')
            .then(response=>{
                this.ticketCategoryItems = response.data
            })
        },
         fetchTicketCategories(){
            Api()
            .get('/ticketCategory')
            .then(response=>{
                this.ticketCategories = response.data
            })
        },
        addItem(){
            if(this.authCreate(this.$store.state.currentRoute)){
                this.ticketItem={}
                this.addModal=true
            }            
        },
        async createNew(){
                    Api()
                    .post('/ticketTemplate',{
                        name: this.ticketItem.name,
                        description: this.ticketItem.description,
                        ticketCategoryItemId: this.ticketItem.ticketCategoryItemId,
                        contactId: this.ticketItem.assignedToId,
                        organisationId: this.ticketItem.organisationId
                    }).then(response=>{
                        this.fetchTicketTemplates()                        
                    })
                    
                    this.addModal=false
                    this.ticketItem={}
            },
           update(){
                Api()
                    .put('/ticketTemplate/'+this.ticketItem.id, {
                         name: this.ticketItem.name,
                        description: this.ticketItem.description,
                        ticketCategoryItemId: this.ticketItem.ticketCategoryItemId,
                        contactId: this.ticketItem.assignedToId,
                        organisationId: this.ticketItem.organisationId
                    }).then(response=>{                     
                        this.fetchTicketTemplates()
                        this.editModal=false                   
                    }) 
                        this.editModal=false   
            },
            editItem(item){
                if(this.authUpdate(this.$store.state.currentRoute)){
                    this.editModal=true
                    this.ticketItem = Object.assign({}, item);
                }
                if(item.ticketCategoryItem!=null){
               this.ticketItem.ticketCategoryId=item.ticketCategoryItem.ticketCategoryId
               this.ticketItem.ticketCategoryItemId=item.ticketCategoryItemId
                }
               
               this.ticketItem.assignedToId=item.contactId
            },
            deleteItem(item){
                if(this.authDelete(this.$store.state.currentRoute)){
                    confirm('Are you sure you want to delete this item?')&&
                    Api()
                    .put('/ticketTemplate/'+item.id,{
                        isActive: false,
                        isDeleted: true
                    })
                    .then(response=>{
                        this.fetchTicketTemplates()   
                    })
                }
            }
            
    }
}
</script>
<style>
.dropClass {
    height:100%;
    margin: 0;
}
</style>